(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ts-price-box"] && !Shopify.designMode) return;
  try {
    (function () {
    function ajouter(date, jours, ouvres) {
      var d = new Date(date.getTime());
      if (!ouvres) {
        d.setDate(d.getDate() + jours);
        return d;
      }
      var reste = jours;
      while (reste > 0) {
        d.setDate(d.getDate() + 1);
        var j = d.getDay();
        if (j !== 0 && j !== 6) reste--;
      }
      return d;
    }
    function texte(d) {
      var jour = d.getDate() === 1 ? '1er' : String(d.getDate());
      return jour + ' ' + d.toLocaleDateString('fr-FR', { month: 'long' });
    }
    function remplir() {
      document.querySelectorAll('[data-ts-delai]').forEach(function (el) {
        var min = parseInt(el.dataset.min, 10);
        var max = parseInt(el.dataset.max, 10);
        if (!min || !max) return;
        var ouvres = el.dataset.ouvres === 'true';
        var auj = new Date();
        el.querySelector('[data-ts-delai-d1]').textContent = texte(ajouter(auj, min, ouvres));
        el.querySelector('[data-ts-delai-d2]').textContent = texte(ajouter(auj, max, ouvres));
        el.querySelector('[data-ts-delai-dates]').hidden = false;
      });
      // v73 : la phrase sur le stock va sous « Livraison offerte » dans l'encadré livraison et retour
      document.querySelectorAll('[data-ts-stock]').forEach(function (p) {
        var r1 = document.querySelector('.text-block[class*="__r1"]');
        if (!r1 || !r1.parentNode) return;
        p.classList.add('ts-delai__stock--encadre');
        r1.parentNode.insertBefore(p, r1.nextSibling);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', remplir);
    else remplir();

    // v84 : secours de la barre d'achat collante d'Horizon. Le thème ne l'affiche que quand son observateur
    // voit le bloc « Ajouter au panier » sortir par le haut ; un saut (ancre « Compose ton setup », défilement
    // rapide) qui passe par-dessus le bloc n'est pas vu et la barre reste cachée. Ici, même règle, au défilement.
    function barre() {
      var bar = document.querySelector('.sticky-add-to-cart__bar[ref="stickyBar"]');
      var bloc = document.querySelector('.buy-buttons-block');
      if (!bar || !bloc) return;
      var pied = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
      var r = bloc.getBoundingClientRect();
      var passe = r.bottom < 0;
      var basDePage = pied ? pied.getBoundingClientRect().top < window.innerHeight + 200 : false;
      var voulu = passe && !basDePage ? 'true' : 'false';
      if (bar.dataset.stuck !== voulu) bar.dataset.stuck = voulu;
    }
    var attenteBarre = false;
    // En capture sur document : sur ordinateur, c'est .page-wrapper qui défile (pas window)
    document.addEventListener(
      'scroll',
      function () {
        if (attenteBarre) return;
        attenteBarre = true;
        requestAnimationFrame(function () {
          attenteBarre = false;
          barre();
        });
      },
      { passive: true, capture: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
